(function() {
  let swiper;

  function initLogoSlider() {
    if (typeof Swiper === "undefined") {
      return;
    }

    if (swiper) {
      swiper.destroy(true, true);
    }

    if (window.innerWidth < 750) {
      swiper = new Swiper(".Index_logo_strip_slider", {
        slidesPerView: 1,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        loop: true,
        autoplay: {
          delay: 1200,
          disableOnInteraction: false,
        }
      });
    } else {
      swiper = new Swiper(".Index_logo_strip_slider", {
        slidesPerView: "auto",
        spaceBetween: 72,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        breakpoints: {
          750: {
            spaceBetween: 64
          },
          1440: {
            spaceBetween: 80
          }
        }
      });
    }
  }

  initLogoSlider();
  window.addEventListener("resize", function() {
    initLogoSlider();
  });
})();
